import { useEffect } from 'react';
import { doc, updateDoc, arrayUnion, increment, getDoc } from 'firebase/firestore';
import ReactGA from 'react-ga4';
import { db } from '../firebase';
import { v4 as uuidv4 } from 'uuid';

const useTrackArticleRead = (articleId, articleTitle) => {
    useEffect(() => {
        if (!articleId) return;

        const sessionKey = `article_read_${articleId}`;

        const hasRead = sessionStorage.getItem(sessionKey);

        if (!hasRead) {
            // 👉 1. Google Analytics
            ReactGA.event({
                category: 'Blog',
                action: 'Read Article',
                label: articleTitle,
            });

            // 👉 2. Firestore: Ajouter dans le tableau uniqueVisitors + incrémenter les vues
            const visitorId =
                localStorage.getItem('visitor_uid') ||
                (() => {
                    const newId = uuidv4();
                    localStorage.setItem('visitor_uid', newId);
                    return newId;
                })();

            const articleRef = doc(db, 'articles', articleId);

            const updateArticleStats = async () => {
                try {
                    const articleSnap = await getDoc(articleRef);
                    const data = articleSnap.data();

                    const alreadyViewed = data?.uniqueVisitors?.includes(visitorId);

                    if (!alreadyViewed) {
                        await updateDoc(articleRef, {
                            views: increment(1),
                            uniqueVisitors: arrayUnion(visitorId),
                        });
                    } else {
                        // Incrémente quand même les vues totales (mais pas les uniques)
                        await updateDoc(articleRef, {
                            views: increment(1),
                        });
                    }

                    sessionStorage.setItem(sessionKey, 'true');
                } catch (error) {
                    console.error('Erreur pendant la mise à jour des stats :', error);
                }
            };

            updateArticleStats();
        }
    }, [articleId, articleTitle]);
};

export default useTrackArticleRead;
